import { attachProfileUsingToken } from "./attachProfileUsingToken";
import { attachProfileWithConnectEmail } from "./attachProfileWithConnectEmail";
import { createProfile } from "./createProfile";
import { createProfileParameterSuggestion } from "./createProfileParameterSuggestion";
import { detachProfile } from "./detachProfile";
import { getCachedQuickApplyParameters } from "./getCachedQuickApplyParameters";
import { getConcernNames } from "./getConcernNames";
import { getConnectUserInfoOverrides } from "./getConnectUserInfoOverrides";
import { getCvPortalCandidateTokenForCurrentUser } from "./getCvPortalCandidateTokenForCurrentUser";
import { getUserOverviews } from "./getUserOverviews";
import { impersonationLogin } from "./impersonationLogin";
import { login } from "./login";
import { me } from "./me";
import { myProfiles } from "./myProfiles";
import { myProfilesWithData } from "./myProfilesWithData";
import { quickApplyConnect } from "./quickApplyConnect";
import { saveCachedQuickApplyParametersOverride } from "./saveCachedQuickApplyParametersOverride";
import { saveConnectUserInfoOverrides } from "./saveConnectUserInfoOverrides";
import { saveLocaleChoice } from "./saveLocaleChoice";
import { sendAttachProfileEmail } from "./sendAttachProfileEmail";
import { whoAmI } from "./whoAmI";

export const authAPI = {
  getCvPortalCandidateTokenForCurrentUser,
  login,
  whoAmI,
  me,
  myProfilesWithData,
  attachProfileUsingToken,
  sendAttachProfileEmail,
  createProfile,
  createProfileParameterSuggestion,
  myProfiles,
  detachProfile,
  saveLocaleChoice,
  getConcernNames,
  quickApplyConnect,
  getUserOverviews,
  attachProfileWithConnectEmail,
  impersonationLogin,
  getCachedQuickApplyParameters,
  saveCachedQuickApplyParametersOverride,
  getConnectUserInfoOverrides,
  saveConnectUserInfoOverrides,
};

export type AuthAPI = typeof authAPI;
